import React, { useState, useEffect } from "react";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import parse from "html-react-parser";
import Icon from "components/Elements/Icon/Icon.tsx";
import Breadcrumb from "components/Reusable/Breadcrumb/Breadcrumb";
import Image from "components/Elements/Image/Image.tsx";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";

const SupportHeader = ({ category, questionDetails, supportMode }) => {
  const { getTextByKey, getLanguageCulture, upperCaseFirstLetter, getPath } =
    useContent();
  const [textSearching, setTextSearching] = useState("");
  const [resultSearch, setResultSearch] = useState(null);
  const [successResultSearch, setSuccessResultSearch] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [iconSerch, setIconSerch] = useState("search");
  const [afterDelayDisplay, setAfterDelayDisplay] = useState(false);

  useEffect(() => {
    if (textSearching && textSearching.length > 2) {
      getSupportQuestionByText(textSearching);
    }
  }, [textSearching]);

  const getSupportQuestionByText = async (textToSearch) => {
    setLoadingSearch(true);
    const parameters = {
      textToSearch: textToSearch,
      culture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "Contents",
      "SearchSupportPage",
      parameters
    );
    if (response.status === "success") {
      setSuccessResultSearch(true);
      if (response.data) {
        if (response.data.length > 0) {
          setResultSearch(response.data);
        } else {
          setResultSearch(null);
        }
      } else {
        setResultSearch(null);
      }
    }
    setIconSerch("x");
    setLoadingSearch(false);
  };

  const cleanResult = (text) => {
    setSuccessResultSearch(false);
    setResultSearch(null);
    setIconSerch("search");
  };

  const searchInSupport = () => {
    if (iconSerch === "x") {
      setTextSearching("");
      cleanResult("");
    } else {
      if (textSearching.length > 2) {
        getSupportQuestionByText(textSearching);
      }
    }
  };
  useEffect(() => {
    if (textSearching && textSearching.length > 2) {
      setTimeout(() => {
        setAfterDelayDisplay(true);
      }, 1000);
    }
  }, [textSearching]);

  const renderResultSearching = () => {
    if (afterDelayDisplay) {
      return (
        <div className="result-search">
          {resultSearch ? (
            resultSearch.map((item, i) => (
              <div className="line-result" key={i}>
                <LinkToNewTab
                  page={`support/a/${item.SystemName.toLowerCase()}`}
                >
                  <div className="title-quest-res">
                    {item.Title && parse(item.Title)}
                  </div>
                  <div className="text-quest-res">
                    {item.AnswerText && parse(item.AnswerText)}
                  </div>
                </LinkToNewTab>
              </div>
            ))
          ) : (
            <div className="no-result">
              <div>
                {parse(
                  replaceTextNoResult(getTextByKey("support-search-no-result"))
                )}
              </div>
              <br />
              <div>{parse(getTextByKey("support-to-contactus"))}</div>
            </div>
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  const replaceTextNoResult = (text) => {
    let tempText = text;
    if (text.includes("#textSearching#")) {
      tempText = tempText.replace("#textSearching#", textSearching);
    }
    return tempText;
  };

  // const getHighlightedText = (text, highlight) => {
  //   // Split text on highlight term, include term itself into parts, ignore case
  //   const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  //   return (
  //     <span>
  //       {parts.map((part) =>
  //         part.toLowerCase() === highlight.toLowerCase() ? <b>{part}</b> : part
  //       )}
  //     </span>
  //   );
  // };

  return (
    <div
      className={`support-header ${
        supportMode === "home" ? "home-categories-header" : "question-header"
      }`}
    >
      {" "}
      {supportMode === "home" ? (
        <div className="support-title-container">
          <h1>
            <b>{getTextByKey("support-display-title")}</b>
          </h1>
          <div className="title-divider"></div>
          {parse(getTextByKey("support-subtitle"))}
        </div>
      ) : null}
      {supportMode === "home" ? (
        <div className="search-container">
          <div className="search-div">
            <div className="input-search">
              <input
                value={textSearching}
                type="text"
                onChange={(e) => setTextSearching(e.target.value)}
                placeholder={getTextByKey("support-search-placeholder")}
              />
              <div className="search-button">
                {loadingSearch ? (
                  <Image name="preloader" ext="gif" alt="" title="" />
                ) : (
                  <Icon onClick={() => searchInSupport()} name={iconSerch} />
                )}
              </div>
            </div>
          </div>
          {successResultSearch && textSearching && (
            <>{renderResultSearching()}</>
          )}
        </div>
      ) : (
        <Breadcrumb>
          {questionDetails && questionDetails.Status ? (
            <a
              id="support-internal-route"
              className="link"
              href={`${getPath()}support`}
            >
              {getTextByKey("upper-SUPPORT", true)}
            </a>
          ) : category && !questionDetails ? (
            <a
              id="support-internal-route"
              className="link"
              href={`${getPath()}support`}
            >
              {getTextByKey("upper-SUPPORT", true)}
            </a>
          ) : null}
          {category && questionDetails && questionDetails.Status ? (
            <>
              <a
                id="support-internal-route"
                className="link"
                href={`${getPath()}support/${
                  category.SystemName.toLowerCase() === "jumbo-embed"
                    ? "jumbo-forms"
                    : category.SystemName.toLowerCase()
                }`}
              >
                {upperCaseFirstLetter(
                  category &&
                    category.CategoryTitle &&
                    category.CategoryTitle === "JUMBOembed"
                    ? "JUMBOforms"
                    : category && category.CategoryTitle
                    ? category.CategoryTitle
                    : ""
                )}
              </a>
            </>
          ) : !questionDetails ? (
            <>
              <span>
                {" "}
                {upperCaseFirstLetter(
                  category &&
                    category.CategoryTitle &&
                    category.CategoryTitle === "JUMBOembed"
                    ? "JUMBOforms"
                    : category && category.CategoryTitle
                    ? category.CategoryTitle
                    : ""
                )}
              </span>
            </>
          ) : null}
          {questionDetails && questionDetails.Status ? (
            <>
              <span id="support-internal-route">{questionDetails.Title}</span>
            </>
          ) : null}
        </Breadcrumb>
      )}
    </div>
  );
};

export default SupportHeader;
